"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterItems = exports.filterItem = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

var _doubleClickableListItem = _interopRequireDefault(require("./double-clickable-list-item"));

require("./dual-list.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var filterItem = function filterItem(item, lowerCaseFilter) {
  return item.label !== null && item.label !== undefined && item.label.toLowerCase().includes(lowerCaseFilter);
};

exports.filterItem = filterItem;

var filterItems = function filterItems(items, filter) {
  var lowerCaseFilter = filter.toLowerCase();
  return items.filter(function (item) {
    return filterItem(item, lowerCaseFilter);
  });
};

exports.filterItems = filterItems;

var DualList = function DualList(_ref) {
  var _assignedContainer$wi, _assignedContainer$he, _unassignedContainer$, _unassignedContainer$2;

  var selectedItems = _ref.selectedItems,
      displayAssignedItemTotals = _ref.displayAssignedItemTotals,
      assignedItemsText = _ref.assignedItemsText,
      notAssignedItemsText = _ref.notAssignedItemsText,
      disabled = _ref.disabled,
      filterable = _ref.filterable,
      filterLabel = _ref.filterLabel,
      selectableItems = _ref.selectableItems,
      selectedFilter = _ref.selectedFilter,
      selectableFilter = _ref.selectableFilter,
      onToggleSelectedItem = _ref.onToggleSelectedItem,
      onToggleSelectableItem = _ref.onToggleSelectableItem,
      onDoubleClickSelectedItem = _ref.onDoubleClickSelectedItem,
      onDoubleClickSelectableItem = _ref.onDoubleClickSelectableItem,
      onChangeSelectedFilter = _ref.onChangeSelectedFilter,
      onChangeSelectableFilter = _ref.onChangeSelectableFilter,
      onSelectAll = _ref.onSelectAll,
      onSelect = _ref.onSelect,
      onDeselect = _ref.onDeselect,
      onDeselectAll = _ref.onDeselectAll;
  var filteredSelectedItems = (0, _react.useMemo)(function () {
    return filterItems(selectedItems, selectedFilter);
  }, [selectedFilter, selectedItems]);
  var filteredSelectableItems = (0, _react.useMemo)(function () {
    return filterItems(selectableItems, selectableFilter);
  }, [selectableFilter, selectableItems]); // get dimensions for virtual list containers

  var _useDimensions = (0, _hooks.useDimensions)(),
      _useDimensions2 = _slicedToArray(_useDimensions, 2),
      unassignedContainerRef = _useDimensions2[0],
      unassignedContainer = _useDimensions2[1];

  var _useDimensions3 = (0, _hooks.useDimensions)(),
      _useDimensions4 = _slicedToArray(_useDimensions3, 2),
      assignedContainerRef = _useDimensions4[0],
      assignedContainer = _useDimensions4[1];

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "dual-list",
    style: {
      height: 'auto'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "list-area-container"
  }, displayAssignedItemTotals ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "assigned-info-container"
  }, /*#__PURE__*/_react["default"].createElement("span", null, assignedItemsText || /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "common.assigned"
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "total"
  }, filteredSelectedItems.length, " / ", selectedItems.length + selectableItems.length)) : null, filterable ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "filter"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    className: (0, _classnames["default"])({
      'search-icon-as-background': !selectedFilter.length
    }),
    disabled: disabled,
    placeholder: filterLabel,
    value: selectedFilter,
    onChange: function onChange(event) {
      return onChangeSelectedFilter(event.target.value);
    }
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.FilterClose, {
    className: "close-filter",
    style: {
      display: selectedFilter.length ? 'block' : 'none'
    },
    onClick: function onClick() {
      return onChangeSelectedFilter('');
    }
  })) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "list-container",
    ref: assignedContainerRef
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.VirtualList, {
    width: (_assignedContainer$wi = assignedContainer.width) !== null && _assignedContainer$wi !== void 0 ? _assignedContainer$wi : 0,
    height: (_assignedContainer$he = assignedContainer.height) !== null && _assignedContainer$he !== void 0 ? _assignedContainer$he : 0,
    options: filteredSelectedItems,
    keyExtractor: function keyExtractor(index) {
      return filteredSelectedItems[index].value;
    },
    optionRenderer: function optionRenderer(_ref2) {
      var key = _ref2.key,
          option = _ref2.option,
          style = _ref2.style,
          measureRef = _ref2.measureRef;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style,
        key: key,
        ref: function ref(el) {
          return measureRef(el);
        }
      }, /*#__PURE__*/_react["default"].createElement(_doubleClickableListItem["default"], {
        selected: option.selected,
        disabled: disabled,
        item: option,
        onClick: function onClick() {
          return onToggleSelectedItem(option);
        },
        onDoubleClick: function onDoubleClick() {
          return onDoubleClickSelectedItem(option);
        }
      }));
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "select-buttons"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "duallist.assignAll"
  }, function (title) {
    return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
      className: "select-button",
      disabled: disabled,
      onClick: onSelectAll,
      icon: true,
      title: title
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.FirstPage, {
      className: "w-4"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "duallist.assign"
  }, function (title) {
    return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
      className: "select-button min-w-0",
      disabled: disabled,
      onClick: onSelect,
      icon: true,
      title: title
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.ChevronLeft, {
      className: "w-4"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "duallist.unassign"
  }, function (title) {
    return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
      className: "select-button",
      disabled: disabled,
      onClick: onDeselect,
      icon: true,
      title: title
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.ChevronRight, {
      className: "w-4"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "duallist.unassignAll"
  }, function (title) {
    return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
      className: "select-button",
      disabled: disabled,
      onClick: onDeselectAll,
      icon: true,
      title: title
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.LastPage, {
      className: "w-4"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "list-area-container"
  }, displayAssignedItemTotals ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "assigned-info-container"
  }, /*#__PURE__*/_react["default"].createElement("span", null, notAssignedItemsText || /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "common.notAssigned"
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "total"
  }, filteredSelectableItems.length, " / ", selectedItems.length + selectableItems.length)) : null, filterable ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "filter"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    className: (0, _classnames["default"])({
      'search-icon-as-background': !selectableFilter.length
    }),
    disabled: disabled,
    placeholder: filterLabel,
    value: selectableFilter,
    onChange: function onChange(event) {
      return onChangeSelectableFilter(event.target.value);
    }
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.FilterClose, {
    className: "close-filter",
    style: {
      display: selectableFilter.length ? 'block' : 'none'
    },
    onClick: function onClick() {
      return onChangeSelectableFilter('');
    }
  })) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "list-container",
    ref: unassignedContainerRef
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.VirtualList, {
    width: (_unassignedContainer$ = unassignedContainer.width) !== null && _unassignedContainer$ !== void 0 ? _unassignedContainer$ : 0,
    height: (_unassignedContainer$2 = unassignedContainer.height) !== null && _unassignedContainer$2 !== void 0 ? _unassignedContainer$2 : 0,
    options: filteredSelectableItems,
    optionRenderer: function optionRenderer(_ref3) {
      var key = _ref3.key,
          option = _ref3.option,
          style = _ref3.style,
          measureRef = _ref3.measureRef;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style,
        key: key,
        ref: function ref(el) {
          return measureRef(el);
        }
      }, /*#__PURE__*/_react["default"].createElement(_doubleClickableListItem["default"], {
        selected: option.selected,
        disabled: disabled,
        item: option,
        onClick: function onClick() {
          return onToggleSelectableItem(option);
        },
        onDoubleClick: function onDoubleClick() {
          return onDoubleClickSelectableItem(option);
        }
      }));
    }
  }))));
};

DualList.propTypes = {
  selectableItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  displayAssignedItemTotals: _propTypes["default"].bool,
  assignedItemsText: _propTypes["default"].node,
  notAssignedItemsText: _propTypes["default"].node,
  disabled: _propTypes["default"].bool,
  filterable: _propTypes["default"].bool,
  selectedItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  onChangeSelectedFilter: _propTypes["default"].func,
  onChangeSelectableFilter: _propTypes["default"].func,
  onSelect: _propTypes["default"].func,
  onDeselect: _propTypes["default"].func,
  onSelectAll: _propTypes["default"].func,
  onDeselectAll: _propTypes["default"].func,
  filterLabel: _propTypes["default"].string,
  selectedFilter: _propTypes["default"].string,
  selectableFilter: _propTypes["default"].string,
  onToggleSelectedItem: _propTypes["default"].func,
  onToggleSelectableItem: _propTypes["default"].func,
  onDoubleClickSelectableItem: _propTypes["default"].func,
  onDoubleClickSelectedItem: _propTypes["default"].func
};

var noop = function noop() {};

DualList.defaultProps = {
  selectableItems: [],
  selectedItems: [],
  onSelect: noop,
  onSelectAll: noop,
  onToggleSelectedItem: noop,
  onDeselect: noop,
  onDeselectAll: noop,
  onToggleSelectableItem: noop,
  onDoubleClickSelectedItem: noop,
  onDoubleClickSelectableItem: noop,
  displayAssignedItemTotals: true,
  assignedItemsText: null,
  notAssignedItemsText: null,
  disabled: false,
  filterable: false,
  filterLabel: 'Filter',
  selectedFilter: '',
  onChangeSelectedFilter: noop,
  selectableFilter: '',
  onChangeSelectableFilter: noop
};
var _default = DualList;
exports["default"] = _default;